import { render, staticRenderFns } from "./UserArea.vue?vue&type=template&id=61e8b9a0"
import script from "./UserArea.vue?vue&type=script&lang=js"
export * from "./UserArea.vue?vue&type=script&lang=js"
import style0 from "./UserArea.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports